import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutAllocationCodeXref extends Layout {
    buttonExpand: Button;
    horizontalspacerForTrailerType: HorizontalSpacer;
    labelCrossRef: Label;
    panelAllocationCode: Panel;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelHeader: Panel;
    sourceEdiCrossRefAllocationCode: DataSource;
    tableCrossRef: Table;
}
